export const getHistoryFilterOverrides = ({
  historyActive = false,
  layerIds = [],
  taxonomyCodes = [],
  bbox,
} = {}) => {
  if (!historyActive) {
    return { layerIds, taxonomyCodes, bbox };
  }
  return {
    layerIds: [],
    taxonomyCodes: [],
    bbox: undefined,
  };
};
